import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {InputSelectLastYearMonth} from '../input-select-last-year-month/InputSelectLastYearMonth'
import {Controller, useFormContext} from 'react-hook-form'
import {CreateAccessFormValidationSchema} from '../../formSchemas'
import {useTranslation} from '@/translations/i18n'
import {InputText} from '@/components/commons/input-text/InputText'
import {AccessInfoFields} from '@/components/commons/access-info-fields/AccessInfoFields'
import {formatDate} from '@/dayjs'

export const AccessFormMonthlySumaryFields = () => {
    const form = useFormContext<CreateAccessFormValidationSchema>()
    const {t} = useTranslation()
    return (
        <Grid columns={2} columnGap={4} rowGap={6} fullWidth>
            <Controller
                control={form.control}
                name="date"
                render={({field, fieldState}) => (
                    <InputSelectLastYearMonth
                        onChange={value => field.onChange(new Date(value))}
                        value={field.value && formatDate(field.value?.toISOString(), 'YYYY-MM-DD')}
                        errorMessage={fieldState.error?.message}
                    />
                )}
            />
            <Grid columns={2} columnGap={4} rowGap={6} fullWidth>
                <InputText
                    type="number"
                    min={1}
                    label={t('accesses:number_of_accesses')}
                    placeholder={t('accesses:number_of_accesses_placeholder')}
                    {...form.register('numberOfAccesses')}
                />
                <AccessInfoFields />
            </Grid>
        </Grid>
    )
}
